import React from "react";
import Modal from "./Modal";

// Dialogo compartido para el 409 APPOINTMENT_OVERLAP (Bloque 2B-2). El texto de `detail` viene
// tal cual del backend (trg_appointments_prevent_overlap) -- no se reescribe aqui.
// El boton de "empalmar de todos modos" NUNCA lleva el estilo destacado (bg-brand-electric):
// empalmar es la excepcion, no el camino feliz.
export default function OverlapConfirmDialog({
  open,
  detail,
  confirming,
  onCancel,
  onConfirm,
  cancelLabel = "Cambiar horario",
  confirmLabel = "Agendar de todos modos",
}) {
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onCancel}
      title="Ya hay una cita a esa hora"
      size="sm"
      testid="modal-overlap-confirm"
      footer={
        <>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirming}
            className="px-4 py-2 text-sm rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-50 disabled:opacity-60"
            data-testid="overlap-confirm"
          >
            {confirming ? "Agendando…" : confirmLabel}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={confirming}
            className="px-4 py-2 text-sm rounded-lg bg-brand-electric text-white hover:bg-blue-700 disabled:opacity-60"
            data-testid="overlap-cancel"
          >
            {cancelLabel}
          </button>
        </>
      }
    >
      <p className="text-sm text-slate-700">{detail}</p>
    </Modal>
  );
}
